function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64 -80)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M187.25,80h-8.333A2.92,2.92,0,0,0,176,82.917v5.417h7.988l-2.744-2.744a.833.833,0,0,1,1.178-1.178l4.167,4.167a.833.833,0,0,1,0,1.178l-4.167,4.167a.833.833,0,0,1-1.178-1.178L183.988,90H176v5.417c0,1.669,1.76,2.917,3.333,2.917h7.917a2.92,2.92,0,0,0,2.917-2.917v-12.5A2.92,2.92,0,0,0,187.25,80Z",
  transform: "translate(-106.167)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.833,240a.833.833,0,1,0,0,1.667h5V240Z",
  transform: "translate(0 -151.667)",
  fill: "currentColor"
}));

var SvgRecipient = function SvgRecipient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    viewBox: "0 0 20 18.333",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecipient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recipient.cc78990a.svg";
export { ForwardRef as ReactComponent };